import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useMemo, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useImmer } from "use-immer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { updateTemporaryAlarmFilters } from "../../../features/Alarms/alarmsSlice";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title, ChartDataLabels);

// Sample data
// const labels = [
//   "OTHER",
//   "VoIP",
//   "UTS-PRS",
//   "SDH&PDH",
//   "MTRC System",
//   "SIP Exchange",
//   "Auto Exchange",
//   "DTMF",
//   "FMS",
//   "VHF-SET",
//   "RAILNET",
//   "SPT",
//   "ETSR",
//   "Quad Cable ",
//   "Magneto",
//   "IPIS System",
// ];
// const counts = [90, 11, 8, 51, 67, 62, 48, 55, 49, 89, 32, 44, 27, 43, 99, 52]; // Alarm counts

// const maxCount = Math.max(...counts) + 10;

// const max = Math.max(...counts);

// const data = {
//   labels,
//   datasets: [
//     {
//       label: "Alarm Count",
//       data: counts,
//       backgroundColor: normalizedOpacities.map((opacity) => `rgba(0, 123, 255, ${opacity})`), // Blue with dynamic opacity
//       borderColor: "rgba(0, 123, 255, 1)",
//       borderWidth: 0,
//     },
//   ],
// };

// const options = {
//   plugins: {
//     legend: { display: false },
//     datalabels: {
//       anchor: "end",
//       align: "end",
//       color: "#000",
//       font: {
//         weight: "bold",
//       },
//       formatter: (value) => value,
//     },
//   },
//   scales: {
//     y: {
//       beginAtZero: true,
//       max: maxCount,
//       ticks: {
//         stepSize: 10,
//       },
//     },
//   },
// };
const initChartData = {
  labels: [],
  counts: [],
};

export default function SytemAarmChart({ system_data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [chartData, setChartData] = useImmer(initChartData);
  console.log("system_data_chart", system_data);

  useEffect(() => {
    const debounce_timer = setTimeout(() => {
      const systemKeys = Object.keys(system_data);
      if (!systemKeys.length) {
        setChartData(initChartData);
        return;
      }
      const counts = systemKeys.map((system) => {
        const system_data_counts = system_data[system]?.counts ?? {};
        return Object.values(system_data_counts).reduce((acc, val) => acc + val, 0);
      });

      setChartData((prev) => {
        prev.labels = systemKeys;
        prev.counts = counts;
      });
    }, 500);

    return () => clearTimeout(debounce_timer);
  }, [system_data]);

  const data_and_options = useMemo(() => {
    const _counts = chartData.counts;
    const max = _counts.length ? Math.max(..._counts) : 0;
    const normalizedOpacities = _counts.map((count) => count / max);
    const data = {
      labels: chartData.labels,
      datasets: [
        {
          label: "Alarm Count",
          data: _counts,
          backgroundColor: normalizedOpacities.map((opacity) => `rgba(0, 123, 255, ${opacity})`), // Blue with dynamic opacity
          borderColor: "rgba(0, 123, 255, 1)",
          borderWidth: 0,
        },
      ],
    };
    const options = {
      //   maintainAspectRatio: false,
      animation: {
        duration: 800, // animation duration in ms
        easing: "easeOutQuart", // easing effect
      },
      plugins: {
        legend: { display: false },
        datalabels: {
          anchor: "end",
          align: "end",
          color: "#000",
          font: {
            weight: "bold",
          },
          formatter: (value) => value,
        },
      },
      onClick: (event, elements, chart) => {
        const softwareTypeLabel = chart.tooltip?.dataPoints[0].label;
        const softwareTypeId = Object.values(system_data).find((system_d) => system_d.software_code == softwareTypeLabel)?.software_id;
        if(!softwareTypeId) {
          toast.error("No such system found");
        }

        const softwareSelected = {
          systemId: softwareTypeId,
          systemName: softwareTypeLabel
        }

        const alarm_params = {
          systems: [softwareSelected],
          limit: 20,
          offset: 0,
          is_active: true,
        };
        dispatch(updateTemporaryAlarmFilters(alarm_params));
        navigate("/alarms");
      },
      scales: {
        y: {
          beginAtZero: true,
          max: max + 10,
          ticks: {
            stepSize: Math.round((max + 10) / 5),
          },
        },
      },
    };
    return {
      data: data,
      options: options,
    };
  }, [chartData]);

  return <Bar height={"100%"} data={data_and_options.data} options={data_and_options.options} />;
}
